import { useAuthContext } from 'context/AuthContext'
import { usePermissionsContext } from 'context/PermissionsContext'

type CanLogicalProps = {
  permission?: string
  permissions?: string[]
  roles?: string[]
}

const CanLogical = ({
  permission,
  permissions,
  roles
}: CanLogicalProps): boolean | null => {
  const { user } = useAuthContext()
  const { hasPermission, hasAnyPermission } = usePermissionsContext()

  if (!user) return null

  if (roles && !roles.includes(user.role)) return false

  if (permission) {
    return hasPermission(permission)
  }

  if (permissions && permissions.length > 0) {
    return hasAnyPermission(permissions)
  }

  // If only roles were provided (no permission), return true if checks passed
  if (roles) return true

  return false
}

export default CanLogical
